import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Compose Tailwind class strings safely: `clsx` flattens arrays /
// conditional maps; `twMerge` resolves Tailwind conflicts (e.g. a later
// `p-2` wins over an earlier `p-4`) so callers can layer overrides
// without worrying about source order.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
